export const dropDriverLicense = ({ customer }) => {
  Object.assign(customer.secondDocument, {
    driverLicense: {
      changed: false,
      drivingExperience: 0,
      issueDate: '',
      issuer: '',
      number: '',
      previousIssueDate: '',
      previousNumber: '',
      previousSeries: '',
      series: '',
      startDate: '',
      whereGivenOut: '',
    },
  });
};
